import { render, staticRenderFns } from "./MapItemSetup.vue?vue&type=template&id=5dbaa5fc&scoped=true"
import script from "./MapItemSetup.vue?vue&type=script&lang=ts"
export * from "./MapItemSetup.vue?vue&type=script&lang=ts"
import style0 from "./MapItemSetup.vue?vue&type=style&index=0&id=5dbaa5fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbaa5fc",
  null
  
)

export default component.exports